import React, { memo } from 'react';
import styles from './DrawerToggleButton.module.scss';

const drawerToggleButton = (props: { drawerToggleClickHandler: () => void; }) => {
    return <button className={styles.toggleButton} onClick={() => props.drawerToggleClickHandler()}>
        <img src="./burger-menu.png" alt="menu" />
    </button>
}

export default memo(drawerToggleButton);